define('constants/contactSortByOptions',[], function () {
    return {
        FirstName: 0,
        LastName: 1
    };
});
